import api from '../api/axios';

export interface Permission {
  id?: number;
  action: string;
  enabled: boolean;
  policy?: string;
}

export interface Role {
  id?: number;
  name: string;
  description?: string;
  type: string;
  permissions?: {
    [key: string]: {
      controllers: {
        [key: string]: {
          [action: string]: {
            enabled: boolean;
            policy?: string;
          };
        };
      };
    };
  };
  users?: any[];
}

const RoleService = {
  getAll: () => api.get('/users-permissions/roles'),
  getOne: (id: number) => api.get(`/users-permissions/roles/${id}`),
  create: (data: Partial<Role>) => api.post('/users-permissions/roles', data),
  update: (id: number, data: Partial<Role>) => api.put(`/users-permissions/roles/${id}`, data),
  delete: (id: number) => api.delete(`/users-permissions/roles/${id}`),
  
  // Get permissions structure
  getPermissions: (id: number) => api.get(`/users-permissions/roles/${id}`),
  
  // Update role permissions
  updatePermissions: (id: number, permissions: any) => 
    api.put(`/users-permissions/roles/${id}`, { permissions }),
  
  // Get role with modules
  getRoleWithModules: async (id: number) => {
    const roleResponse = await api.get(`/users-permissions/roles/${id}`);
    const modulesResponse = await api.get(`/role-module-accesses/role/${id}`);
    return {
      ...roleResponse,
      modules: modulesResponse.data?.data || [],
    };
  },
};

export default RoleService;

